import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { IngresoService } from '../../servicios/ingreso.service';

@Component({
  selector: 'app-slider-admin',
  templateUrl: './slider-admin.component.html',
  styleUrls: ['./slider-admin.component.css'],
  providers: [NgbModalConfig, NgbModal]
})
export class SliderAdminComponent implements OnInit {

  public mr: NgbModalRef;
  public vecAjustes = [];

  constructor(private modalService: NgbModal, config: NgbModalConfig, private alerti: AlertifyService, private srvSelect: SeleccionService, private srvInsert: IngresoService) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
  }
  //FUNCION QUE ABRE EL MODAL PARA VER LOS AJUSTES DEL SISTEMA
  async modalAjustes(modAjuste) {
    this.vecAjustes = [];
    const res = await new Promise<any>(resolve => this.srvSelect.gestionOtros(2, 'na').subscribe(translated => { resolve(translated) }));
    if (res.success) {
      this.vecAjustes = res.ajustes;
      this.mr = this.modalService.open(modAjuste);
    }
  }
  //FUNCION QUE GUARDA LOS AJUSTES DEL SISTEMA
  guardarAjustes(idAjuste, describe, valor) {
    this.srvInsert.ingresoGestionAjustes(idAjuste, describe, valor, 1).subscribe(res => {
      if (res.ajuste) {
        this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), 'SUPER ADMINISTRADOR', describe, 'EDITAR Términos y condiciones postulación de becas', 1, valor, 1).subscribe(res => {
        });
        this.alerti.success('Cambios realizados');
      }
    });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }

}
